import React from 'react';

export const LoadingBlock = () => <p style={{ border: "1px solid #ddd", color: "#999", margin: "20px 0", padding: 20 }}>Loading...</p>

export const Loading = () => <p style={{ color: "#999", margin: "20px 0" }}>Loading...</p>;
export default Loading;